export default "__VITE_ASSET__DID6ynQ1__"